import { useAccountRepository } from '@frontend/repository';

export const useCreateTemplateModal = () => {
    const { currentAccount } = useAccountRepository();
    const templateModalId = 'create-notification-template-modal';

    return {
        currentAccount,
        templateModalId
    };
};
